import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'ru'],
  defaultLocale: 'ru',
  localePrefix: 'as-needed',
  localeDetection: false,
});
